// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"5520c4c56caf10a6ec68","105":"f9c67462c65a7a89589f","108":"f03079819f8757c97349","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"95305c3b8bf42cd11582","852":"b663edd957f49e4c36a0"}[chunkId] + ".bundle.js";
};